import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3dd2e005&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=3dd2e005&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2e005",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd2e005')) {
      api.createRecord('3dd2e005', component.options)
    } else {
      api.reload('3dd2e005', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=3dd2e005&scoped=true&", function () {
      api.rerender('3dd2e005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/Home.vue"
export default component.exports